import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Input from '../../components/ui/Input';
import Button from '../../components/ui/Button';
import { useAuth } from '../../context/AuthContext';
const ForgotPassword: React.FC = () => {
  const [step, setStep] = useState<'phone' | 'otp' | 'reset'>('phone');
  const [phone, setPhone] = useState('');
  const [otp, setOtp] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const {
    forgotPassword,
    resetPassword
  } = useAuth();
  const handlePhoneSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    try {
      await forgotPassword(phone);
      setStep('otp');
    } catch (err) {
      setError('Error sending OTP. Please try again.');
    }
  };
  const handleOtpSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (otp.length !== 6) {
      setError('Please enter a valid 6-digit OTP');
      return;
    }
    setStep('reset');
  };
  const handleResetSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (newPassword !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    try {
      await resetPassword(otp, newPassword);
      setSuccess(true);
    } catch (err) {
      setError('Error resetting password. Please try again.');
    }
  };
  if (success) {
    return <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4" data-id="element-198">
        <div className="max-w-md w-full bg-white rounded-lg border border-gray-200 shadow-md p-8 text-center" data-id="element-199">
          <div className="text-green-500 text-5xl mb-4" data-id="element-200">✓</div>
          <h2 className="text-2xl font-semibold mb-2" data-id="element-201">
            Password Reset Successfully
          </h2>
          <p className="text-gray-600 mb-6" data-id="element-202">
            Your password has been reset successfully.
          </p>
          <Link to="/login" data-id="element-203">
            <Button fullWidth data-id="element-204">Back to Login</Button>
          </Link>
        </div>
      </div>;
  }
  return <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4" data-id="element-205">
      <div className="max-w-md w-full bg-white rounded-lg border border-gray-200 shadow-md p-8" data-id="element-206">
        <div className="text-center mb-8" data-id="element-207">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bzuBe8K7tpwiJaFhSgXiCs/image.png" alt="Just Cheetah" className="mx-auto h-12 mb-4" data-id="element-208" />
          <h2 className="text-2xl font-semibold" data-id="element-209">Forgot Password</h2>
          <p className="text-gray-600 mt-1" data-id="element-210">
            {step === 'phone' && 'Enter your mobile number to reset your password'}
            {step === 'otp' && 'Enter the OTP sent to your mobile number'}
            {step === 'reset' && 'Create a new password'}
          </p>
        </div>
        {error && <div className="mb-4 bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded" data-id="element-211">
            {error}
          </div>}
        {step === 'phone' && <form onSubmit={handlePhoneSubmit} data-id="element-212">
            <Input label="Mobile No." type="tel" placeholder="Enter your mobile number" value={phone} onChange={e => setPhone(e.target.value)} required data-id="element-213" />
            <Button type="submit" fullWidth size="lg" data-id="element-214">
              Send OTP
            </Button>
          </form>}
        {step === 'otp' && <form onSubmit={handleOtpSubmit} data-id="element-215">
            <Input label="OTP" type="text" placeholder="Enter 6-digit OTP" value={otp} onChange={e => setOtp(e.target.value)} required data-id="element-216" />
            <Button type="submit" fullWidth size="lg" data-id="element-217">
              Verify OTP
            </Button>
          </form>}
        {step === 'reset' && <form onSubmit={handleResetSubmit} data-id="element-218">
            <Input label="New Password" type="password" placeholder="Enter new password" value={newPassword} onChange={e => setNewPassword(e.target.value)} required data-id="element-219" />
            <Input label="Confirm Password" type="password" placeholder="Confirm new password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} required data-id="element-220" />
            <Button type="submit" fullWidth size="lg" data-id="element-221">
              Reset Password
            </Button>
          </form>}
        <div className="text-center mt-8" data-id="element-222">
          <Link to="/login" className="text-[#E84118] hover:underline" data-id="element-223">
            Back to Login
          </Link>
        </div>
      </div>
    </div>;
};
export default ForgotPassword;